import { render, staticRenderFns } from "./comPhoneEdit.vue?vue&type=template&id=051d9cc5&scoped=true&"
import script from "./comPhoneEdit.vue?vue&type=script&lang=js&"
export * from "./comPhoneEdit.vue?vue&type=script&lang=js&"
import style0 from "./comPhoneEdit.vue?vue&type=style&index=0&id=051d9cc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051d9cc5",
  null
  
)

export default component.exports